export const API_END_POINT = import.meta.env.VITE_PASS_OAUTH_URL
export const API_URL = import.meta.env.VITE_PASS_URL
export const SERVICES_URL = import.meta.env.VITE_SERVICES_URL
